<template>
  <el-form ref="form" :model="carouselForm" :rules="rules" class="carousel-list">
    <el-form-item v-for="lang in languages" :key="lang" :label="languageMap[lang]" :prop="lang" class="carousel-item">
      <div>
        <div class="ft-12">
          <BatchEditImages
            v-model="carouselForm[lang].url"
            :refName="`carouselImage_${lang}`"
            :getWidthAndHeights="getWidthAndHeights"
          ></BatchEditImages>
        </div>
        <MutiImgUpload :ref="`carouselImage_${lang}`" v-model="carouselForm[lang].url" :mainImgNums="0" :autoCropImageParams="autoCropImageParams" v-bind="imgLimits" :size="100" />
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue';
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';
import { cloneDeep, isEqual, isEmpty } from 'lodash';

export default {
  components: {
    BatchEditImages,
    MutiImgUpload,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    languageMap: {
      type: Object,
      default() {
        return {};
      },
    },
    languages: {
      type: Array,
      default() {
        return ['en'];
      },
    },
    initCarouselImage: {
      type: Array,
      default() {
        return [];
      },
    },

    value: {
      type: Array,
      default() {
        return [];
      },
    },
    imgNames: {
      type: Array,
      default() {
        return [];
        // return ['正面图', '细节图', '细节图', '场景图', '场景图'];
      },
    },
    imgLimits: {
      type: Object,
      default() {
        return {};
      },
    },
    autoCropImageParams:{
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      carouselForm: {},
      rules: {},
      isInitForm:false,
      isCanEmit: true,
    };
  },
  watch: {
    carouselForm: {
      handler(v, oldV) {
        if (isEmpty(v)) return;
        if (!this.isCanEmit) return;
        this.$emit('change', cloneDeep(Object.values(this.carouselForm)));
      },
      deep: true,
    },
    value:{
      handler(v){
        if(!this.isInitForm){
          this.initForm(true);
        }
      },
      deep:true,
    },
    languages:{
      handler(v){
        this.initForm();
      },
      deep:true,
      immediate:true,
    }
  },
  methods: {
    getWidthAndHeights(refName) {
      return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : [];
    },
    initForm(isInitValue) {
      if(isInitValue){
        this.isInitForm = true;
      }
      this.isCanEmit = false // initForm方法内修改的carouselForm不触发$emit事件
      ;(this.languages || []).map(lang => {
        const findItem = this.value.find(item => item.language === lang) || {};
        this.$set(this.carouselForm, lang, {
          language: lang,
          url: findItem.url || [],
        });
        this.$set(this.rules, lang, this.getItemRule(lang));
      });
      this.$nextTick(()=>{
        this.isCanEmit = true
      });
    },
    getItemRule(lang) {
      return [
        { required: true, message: '图片不能为空' },
        {
          validator: async (rule, value, callback) => {
            const len = value.url?.length || 0;
            if (len === 0) return callback(new Error('图片不能为空'));
            if (len < 5) return callback(new Error('请至少上传5张图片'));
            if (len > 10) return callback(new Error('最多上传10张图片'));
            // 校验图片有效性
            const ref = this.$refs[`carouselImage_${lang}`];
            if (ref && ref[0]?.method_validImage) {
              const errMsg = await ref[0].method_validImage();
              if (errMsg) return callback(new Error(errMsg));
            }
            return callback();
          },
        },
      ];
    },
    validate() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          resolve(valid);
        });
      });
    },
  },
  mounted(){
  }
};
</script>

<style lang="scss" scoped>
.carousel-list {
  padding: 15px;
  max-height: 264px;
  overflow-y: scroll;
  // background: #f9f9fa;
  .carousel-item {
    display: flex;
    align-items: center;
    padding-bottom: 22px;
    ::v-deep .el-form-item__label {
      width: 70px;
    }
  }
}
</style>